import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { AcornsIcon } from '@acorns/icons';
import { format } from 'date-fns';
import Reel from 'react-reel';
import { theme } from '../theme';
import { USDFormatter } from '../utils/number';
import { PERFORMANCE_CURRENT_PRICE, PERFORMANCE_PRICE_CHANGE } from '../utils/testing/TestIDs';
import { Tooltip } from './Tooltip';
import { CustomLine } from './Chart/CustomLine';
import { ChartSelect } from './Chart/ChartSelect';
import { buildTooltip } from './Tooltip/tooltips';
import { PerformanceChartContainer } from './styled-components';
import { PerformancePriceContainer, PerformancePrice, PerformanceGainLossContainer, PerformanceGainLossAmount, PerformanceGainLossDate, PerformanceChartFooter } from './styled-components';
var a4reelTheme = {
  reel: {
    height: '1.0em',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'left',
    overflowY: 'hidden',
    fontSize: '30px',
    fontWeight: '600',
    paddingBottom: '5px',
    lineHeight: '38px'
  },
  group: {
    transitionDelay: '0ms',
    transitionTimingFunction: 'linear',
    transform: 'translate(0, 0)',
    height: '1em'
  },
  number: {
    height: '1em'
  }
};
export var getUpOrDownIcon = function getUpOrDownIcon(amount) {
  var ArrowIcon = AcornsIcon.Icon.ArrowUp;

  if (amount.includes('-')) {
    ArrowIcon = AcornsIcon.Icon.ArrowDown;
  }

  return ArrowIcon;
};
export var PerformanceGraph = function PerformanceGraph(_ref) {
  var _tooltip$currentIndex;

  var data = _ref.data,
      selectedTimeframe = _ref.selectedTimeframe,
      sinceDate = _ref.sinceDate,
      gainLoss = _ref.gainLoss,
      lineColor = _ref.lineColor,
      timeFrameOptions = _ref.timeFrameOptions,
      footer = _ref.footer,
      className = _ref.className,
      selectHandler = _ref.selectHandler;

  var _useState = useState({
    accountValue: null,
    currentIndex: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      tooltip = _useState2[0],
      setTooltip = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showTooltip = _useState4[0],
      setShowTooltip = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isScrubbing = _useState6[0],
      setIsScrubbing = _useState6[1];

  var currentTimeframe = timeFrameOptions.findIndex(function (_ref2) {
    var id = _ref2.id;
    return id === selectedTimeframe;
  });
  var prices = data.map(function (item) {
    return item.value;
  });
  var timestamps = data.map(function (item) {
    return item.timestamp;
  });
  var currentPrice = (tooltip === null || tooltip === void 0 ? void 0 : tooltip.accountValue) ? tooltip.accountValue : prices[prices.length - 1];

  var buildLocalTooltip = function buildLocalTooltip(event) {
    return buildTooltip(event.nativeEvent, data.map(function (item) {
      return item.value;
    }), data.map(function (item) {
      return timeFrameOptions[currentTimeframe].displayTime ? format(new Date(item.timestamp), "hh:mm aaaaa'm'").toUpperCase() : format(new Date(item.timestamp), 'MMM dd yyyy');
    }), true);
  };

  var handleSelect = function handleSelect(selected) {
    // Call setHandler prop function and remove tooltip
    selectHandler(selected);
    setTooltip({
      accountValue: null,
      currentIndex: null
    });
  };

  var eventHandler = function eventHandler(event) {
    if (event.type === 'mousedown' || event.type === 'touchstart') {
      var currentTooltip = buildLocalTooltip(event);

      if (currentTooltip) {
        setTooltip(currentTooltip);
        setIsScrubbing(true);
        setTimeout(function () {
          setShowTooltip(true);
        }, 250);
      }
    }

    if ((event.type === 'mousemove' || event.type === 'touchmove') && isScrubbing) {
      var _currentTooltip = buildLocalTooltip(event);

      if (_currentTooltip) {
        setTooltip(_currentTooltip);
      }
    }

    if (event.type === 'mouseup' || event.type === 'click' || event.type === 'touchend') {
      setTooltip({
        accountValue: null,
        currentIndex: null
      });
      setShowTooltip(false);
      setIsScrubbing(false);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(PerformancePriceContainer, null, /*#__PURE__*/React.createElement(PerformancePrice, {
    "data-testid": PERFORMANCE_CURRENT_PRICE
  }, /*#__PURE__*/React.createElement(Reel, {
    text: USDFormatter.format(parseFloat(currentPrice)),
    theme: a4reelTheme,
    delay: 0,
    duration: 600
  })), /*#__PURE__*/React.createElement(PerformanceGainLossContainer, null, /*#__PURE__*/React.createElement(AcornsIcon, {
    height: "13px",
    icon: getUpOrDownIcon(gainLoss),
    width: "10px"
  }), /*#__PURE__*/React.createElement(PerformanceGainLossAmount, {
    "data-testid": PERFORMANCE_PRICE_CHANGE
  }, gainLoss), sinceDate && /*#__PURE__*/React.createElement(PerformanceGainLossDate, null, "Since ", sinceDate))), /*#__PURE__*/React.createElement(PerformanceChartContainer, {
    onClick: eventHandler,
    onMouseDown: eventHandler,
    onMouseMove: eventHandler,
    onMouseUp: eventHandler,
    onTouchStart: eventHandler,
    onTouchMove: eventHandler,
    onTouchEnd: eventHandler
  }, tooltip.accountValue && showTooltip && /*#__PURE__*/React.createElement(Tooltip, {
    lineColor: lineColor !== null && lineColor !== void 0 ? lineColor : theme.colors.greenDark,
    lineHeight: 210,
    tooltip: tooltip,
    showLegend: showTooltip,
    selectedIndex: currentTimeframe
  }), /*#__PURE__*/React.createElement(CustomLine, {
    prices: prices,
    timestamps: timestamps,
    tooltipActive: tooltip.accountValue,
    lineColor: lineColor !== null && lineColor !== void 0 ? lineColor : theme.colors.greenDark,
    currentTooltipIndex: (_tooltip$currentIndex = tooltip.currentIndex) !== null && _tooltip$currentIndex !== void 0 ? _tooltip$currentIndex : 0
  })), /*#__PURE__*/React.createElement(ChartSelect, {
    options: timeFrameOptions,
    selectHandler: handleSelect,
    selectedIndex: timeFrameOptions.findIndex(function (_ref3) {
      var id = _ref3.id;
      return id === selectedTimeframe;
    })
  }), footer && /*#__PURE__*/React.createElement(PerformanceChartFooter, null, footer));
};